import { Component } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'app-blank-page',
  imports: [],
  template: `
    <div class="app-container">
      <header class="main-header">
        <div class="brand-header">
          <div class="brand-icon-header">D</div>
          <span class="brand-text-header">
            <span style="color: #000000;">Doc</span><span style="color: #5b6cf2;">Sila</span>
          </span>
        </div>
        
        <div class="header-nav-buttons">
          <button class="header-nav-btn" (click)="navigateToSequencing()" title="Sequencing">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
              <line x1="10" y1="6" x2="21" y2="6"></line>
              <line x1="10" y1="12" x2="21" y2="12"></line>
              <line x1="10" y1="18" x2="21" y2="18"></line>
              <path d="M4 6h1v4"></path>
              <path d="M4 10h2"></path>
              <path d="M6 18H4c0-1 2-2 2-3s-1-1.5-2-1"></path>
            </svg>
          </button>
          <button class="header-nav-btn" title="Data Extraction">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
              <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"></path>
              <polyline points="14 2 14 8 20 8"></polyline>
              <line x1="16" y1="13" x2="8" y2="13"></line>
              <line x1="16" y1="17" x2="8" y2="17"></line>
              <polyline points="10 9 9 9 8 9"></polyline>
            </svg>
          </button>
          <button class="header-nav-btn" title="Versioning">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
              <line x1="6" y1="3" x2="6" y2="15"></line>
              <circle cx="18" cy="6" r="3"></circle>
              <circle cx="6" cy="18" r="3"></circle>
              <path d="M18 9a9 9 0 0 1-9 9"></path>
            </svg>
          </button>
          <button class="header-nav-btn" title="External Mapping">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
              <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z"></path>
              <polyline points="3.27 6.96 12 12.01 20.73 6.96"></polyline>
              <line x1="12" y1="22.08" x2="12" y2="12"></line>
            </svg>
          </button>
          <button class="header-nav-btn" (click)="navigateToExtractionEval()" title="Eval">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nav-icon">
              <polyline points="9 11 12 14 22 4"></polyline>
              <path d="M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11"></path>
            </svg>
          </button>
        </div>
      </header>
    </div>
  `,
  styles: [`
    .app-container {
      display: flex;
      flex-direction: column;
      height: 100vh;
      background: #f8f9fa;
    }

    .main-header {
      background: white;
      border-bottom: 1px solid #e0e0e0;
      padding: 0 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 60px;
      position: sticky;
      top: 0;
      z-index: 100;
    }

    .brand-header {
      display: flex;
      align-items: center;
      gap: 0.75rem;
    }

    .brand-icon-header {
      width: 36px;
      height: 36px;
      background: linear-gradient(135deg, #5b6cf2 0%, #4a5de1 100%);
      border-radius: 8px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: white;
      font-weight: 700;
      font-size: 1.125rem;
      letter-spacing: -0.5px;
    }

    .brand-text-header {
      font-size: 1.25rem;
      font-weight: 700;
      letter-spacing: -0.5px;
    }

    .header-nav-buttons {
      display: flex;
      gap: 0.5rem;
    }

    .header-nav-btn {
      padding: 0.5rem;
      background: transparent;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      transition: all 0.2s ease;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .header-nav-btn:hover {
      background: rgba(91, 108, 242, 0.1);
    }

    .header-nav-btn.active {
      background: rgba(91, 108, 242, 0.15);
    }

    .nav-icon {
      color: #5b6cf2;
    }
  `]
})
export class BlankPageComponent {
  constructor(private router: Router) {}

  navigateToSequencing(): void {
    this.router.navigate(['/']);
  }

  navigateToExtractionEval(): void {
    this.router.navigate(['/dashboard']);
  }
}
